module.exports = __webpack_public_path__ + "img/logo-fiducie.617ecca2.png";